/* eslint-disable-next-line import/named */
import styled from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { AUTO_WIDTH_BREAKPOINT, StyledButton } from '../Button/Button.styles';
const getButtonSpacing = (props) => {
    switch (props.variant) {
        case 'block-buttons':
            return `var(${props.theme.responsive.spacing.xxs})`;
        case 'text-buttons':
            return `var(${props.theme.responsive.spacing.l})`;
    }
};
export const StyledContainer = styled.div `
  ${injectSpacing('margin')}
`;
export const StyledButtonGroup = styled.div `
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  margin-inline-end: calc(${getButtonSpacing} * -1);
  margin-block-end: calc(${getButtonSpacing} * -1);

  @media (min-width: ${AUTO_WIDTH_BREAKPOINT}) {
    display: ${(props) => (props.block ? 'flex' : 'inline-flex')};
  }

  ${StyledButton} {
    margin-inline-end: ${getButtonSpacing};
    margin-block-end: ${getButtonSpacing};
  }
`;
//# sourceMappingURL=ButtonGroup.styles.js.map